const version = '2.6.28';
export { version };
